import React, { useEffect, useRef, useState } from "react";
import {
    Button, Table, Overlay,
    Popover, Col, Form, Row
} from "react-bootstrap";
import Loader from "../../../Loader/Loader";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import Comments from "../Comments/Comment";
import upArrow from "../../../../Assets/Images/Glance Dashboard/GlanceUp.svg";
import downArrow from "../../../../Assets/Images/Glance Dashboard/GlanceDown.svg";
import emailIcon from "../../../../Assets/Images/Email.svg";
import CompSetVarianceChart from "../../CompSetVarianceChart";

export const CompsetVariance = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const [showToolsSummaryModal, setToolsSummaryModal] = useState(false);
    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const propertyDetailFromRTK = useSelector((store) => store.headerProperty.propertyDetail);

    const defaultAsOfDateFromRTK = useSelector((store) => store.headerProperty.defaultAsOfDate);

    const [tblids, settblids] = useState({
        id1: commonService.GenerateGUID(),
    });
    const [ClickedDate, setClickedDate] = useState(new Date());
    const [CompetitorProperty, setCompetitorProperty] = useState("");


    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };


    const closeToolsSummaryModal = () => {
        setToolsSummaryModal(false);
    }

    const [compsetVarianceLoading, setCompsetVarianceLoading] = useState(false);
    const [compsetVarianceData, setCompsetVarianceData] = useState(null);

    const getCompRateVariane = async () => {
        setCompsetVarianceLoading(true);
        let compRateVarianeResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.REVENUE_GLANCE.COMP_RATE_VARIANCE_WITH_OCC_SELF,
                body: {
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let response = apiResponse(false, compRateVarianeResponse);

        if (response?.isValidate) {
            setCompsetVarianceData(response?.data?.data);
            setCompsetVarianceLoading(false);
        }

        if (!response?.isValidate) {
            setCompsetVarianceData(null);
            setCompsetVarianceLoading(false);
        }
    };

    useEffect(() => {
        if (api === 0) {

        } else {
            if (para?.propertyCode) {
                getCompRateVariane();
            }
        }
    }, [para?.propertyCode]);

    return (
        <div className="widget-container" style={{ position: "relative" }}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button
                        className="heading-menu-btns"
                        type="button"
                        title="Send Mail"
                    >
                        <img id={commonService.generateGlobalClickTrackerID("CompsetVariance", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.id1,
                                    "CompsetVariance",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("CompsetVariance", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.CompsetVariance,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("CompsetVariance", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.id1}
                            onClick={() =>
                                commonService.fnExportInCSV(
                                    tblids.id1,
                                    `${para?.propertyCode}-CompsetVariance-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                )
                            }
                        />
                    </Button>
                </div>
            )}
            <Row>
                <Col xl={12}>
                    <div className="ViewPropertySetupTable">
                        <div className="stripped__table">
                            <div className="table-responsive tblDynamicPickupSticky">
                                <Table className="table-with-spacing positionStaticTable dailySummaryTbl" id={tblids?.id1}>
                                    <thead className="tbl-header-sticky">
                                        <tr className="table-main-header-tr">
                                            <th className="text-center border_right" colSpan={3}>
                                                Self
                                            </th>
                                            <th className="text-center" colSpan={6}>
                                                Compset Variance
                                            </th>
                                        </tr>
                                        <tr className="table-main-header-tr">
                                            <th className="border_right text-center">Occ%</th>
                                            <th className="text-end border_right">ADR</th>
                                            <th className="text-end border_right">BAR Rate</th>

                                            <th className="border_right">Check In Date</th>
                                            <th className="border_right">Competitor Property Name</th>
                                            <th className="text-end border_right">Previous Rate</th>
                                            <th className="text-end border_right">Current Rate</th>
                                            <th className="text-end border_right">Rate Variance</th>
                                            <th className="text-center">%Change</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {compsetVarianceLoading ? (
                                            <tr style={{ height: "80px", position: "relative" }}>
                                                <Loader />
                                            </tr>
                                        ) : compsetVarianceData?.length > 0 ? (
                                            compsetVarianceData?.map((item) => {
                                                return (
                                                    <tr className={`shadowOnHover`}>
                                                        <td className="border_right text-center">
                                                            {item?.Occperc ? item?.Occperc : 0}%
                                                        </td>
                                                        <td className="text-end border_right">
                                                            {item?.ADR
                                                                ? commonService.formateAmount(
                                                                    Math.round(item?.ADR)
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="text-end border_right">
                                                            {item?.SelfRate
                                                                ? commonService.formateAmount(
                                                                    Math.round(item?.SelfRate)
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="border_right">
                                                            {item?.CheckInDate
                                                                ? commonService.getDateInFormat(
                                                                    item?.CheckInDate
                                                                )
                                                                : ""}
                                                        </td>
                                                        <td id={commonService.generateGlobalClickTrackerID("CompsetVariance", "compset-variance-competitor-propert", item)} onClick={() => {
                                                            setClickedDate(item?.CheckInDate);
                                                            setCompetitorProperty(item?.competiterpropertyname)
                                                            setToolsSummaryModal(true);
                                                        }} className="border_right cursorPointer text-primary" >
                                                            {item?.competiterpropertyname}
                                                        </td>

                                                        <td className="text-end border_right">
                                                            {item?.PreviousCompRate
                                                                ? commonService.formateAmount(
                                                                    Math.round(item?.PreviousCompRate)
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="text-end border_right">
                                                            {item?.CurrentCompRate
                                                                ? commonService.formateAmount(
                                                                    Math.round(item?.CurrentCompRate)
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="text-end border_right">
                                                            {item?.RateDifference
                                                                ? commonService.formateAmount(
                                                                    Math.round(item?.RateDifference)
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="text-center">
                                                            <div
                                                                className={`compSetPerChange ${item?.PercentageChange > 0
                                                                    ? "compSetPerChangeBgPositive"
                                                                    : "compSetPerChangeBgNegative"
                                                                    }`}
                                                            >
                                                                <p>
                                                                    {item?.PercentageChange
                                                                        ? `${item?.PercentageChange}%`
                                                                        : `0%`}
                                                                </p>
                                                                {item?.PercentageChange > 0 ? (
                                                                    <img src={upArrow} />
                                                                ) : (
                                                                    <img src={downArrow} />
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr className="text-center">
                                                <td colSpan={9}>No Data Found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            {api !== 0 && <Comments widgetDetails={para} editorId={"CompsetVariance"} />}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}

            {showToolsSummaryModal && (
                <CompSetVarianceChart
                    showToolsSummaryModal={showToolsSummaryModal}
                    closeToolsSummaryModal={closeToolsSummaryModal}
                    selectedDate={ClickedDate}
                    propertyDetail={propertyDetailFromRTK}
                    CompetitorProperty={CompetitorProperty}
                />
            )}
        </div>
    );
};


export default CompsetVariance;
